import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Plus,
  Search,
  Edit,
  Trash2,
  X,
  ChevronUp,
  ChevronDown,
  RotateCcw,
  Users as UsersIcon,
  RefreshCw
} from 'lucide-react';
import { customersAPI } from '../utils/api';
import { useAuth } from '../contexts/AuthContext';
import { useNotification } from '../contexts/NotificationContext';
import PageToolbar from '../components/PageToolbar';
import { displayUpperCase } from '../utils/textUtils';

const Customers = () => {
  const {
    user,
    canCreateCustomer,
    canUpdateCustomer,
    canDeleteCustomer
  } = useAuth();
  const { showSuccess, showError } = useNotification();

  // Helper functions for number formatting
  const formatNumberForDisplay = (value) => {
    if (value === null || value === undefined || isNaN(value)) return '0,00';
    return new Intl.NumberFormat('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  };

  const parseFormattedNumber = (formattedValue) => {
    if (!formattedValue) return 0;
    // Remove dots (thousands separators) and replace comma with dot for decimal
    const cleanValue = formattedValue.replace(/\./g, '').replace(',', '.');
    const parsed = parseFloat(cleanValue);
    return isNaN(parsed) ? 0 : parsed;
  };

  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [sortBy, setSortBy] = useState('createdAt');
  const [sortOrder, setSortOrder] = useState('desc');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showBalanceModal, setShowBalanceModal] = useState(false);
  const [showCustomersListModal, setShowCustomersListModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showDeletedCustomers, setShowDeletedCustomers] = useState(false);
  const [deletedCustomers, setDeletedCustomers] = useState([]);
  const [deletedCustomersLoading, setDeletedCustomersLoading] = useState(false);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [stats, setStats] = useState({ totalCustomers: 0, newThisPeriod: 0, activeCustomers: 0 });



  // Ay seçimi kaldırıldı

  // Form state
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    tcNumber: '',
    address: '',
    city: '',
    district: '',
    preferredColors: [],
    preferredBrands: [],
    smsPermission: true,
    emailPermission: true,
    notes: ''
  });

  // Turkish districts data
  const districtsData = {
    'Adana': ['Aladağ', 'Ceyhan', 'Çukurova', 'Feke', 'İmamoğlu', 'Karaisalı', 'Karataş', 'Kozan', 'Pozantı', 'Saimbeyli', 'Sarıçam', 'Seyhan', 'Tufanbeyli', 'Yumurtalık', 'Yüreğir'],
    'Adıyaman': ['Besni', 'Çelikhan', 'Gerger', 'Gölbaşı', 'Kahta', 'Merkez', 'Samsat', 'Sincik', 'Tut'],
    'Afyonkarahisar': ['Başmakçı', 'Bayat', 'Bolvadin', 'Çay', 'Çobanlar', 'Dazkırı', 'Dinar', 'Emirdağ', 'Evciler', 'Hocalar', 'İhsaniye', 'İscehisar', 'Kızılören', 'Merkez', 'Sandıklı', 'Sinanpaşa', 'Sultandağı', 'Şuhut'],
    'Ağrı': ['Diyadin', 'Doğubayazıt', 'Eleşkirt', 'Hamur', 'Merkez', 'Patnos', 'Taşlıçay', 'Tutak'],
    'Amasya': ['Göynücek', 'Gümüşhacıköy', 'Hamamözü', 'Merkez', 'Merzifon', 'Suluova', 'Taşova'],
    'Ankara': ['Akyurt', 'Altındağ', 'Ayaş', 'Bala', 'Beypazarı', 'Çamlıdere', 'Çankaya', 'Çubuk', 'Elmadağ', 'Etimesgut', 'Evren', 'Gölbaşı', 'Güdül', 'Haymana', 'Kalecik', 'Kazan', 'Keçiören', 'Kızılcahamam', 'Mamak', 'Nallıhan', 'Polatlı', 'Pursaklar', 'Sincan', 'Şereflikoçhisar', 'Yenimahalle'],
    'Antalya': ['Akseki', 'Aksu', 'Alanya', 'Demre', 'Döşemealtı', 'Elmalı', 'Finike', 'Gazipaşa', 'Gündoğmuş', 'İbradı', 'Kaş', 'Kemer', 'Kepez', 'Konyaaltı', 'Korkuteli', 'Kumluca', 'Manavgat', 'Muratpaşa', 'Serik'],
    'Artvin': ['Ardanuç', 'Arhavi', 'Borçka', 'Hopa', 'Merkez', 'Murgul', 'Şavşat', 'Yusufeli'],
    'Aydın': ['Bozdoğan', 'Buharkent', 'Çine', 'Didim', 'Efeler', 'Germencik', 'İncirliova', 'Karacasu', 'Karpuzlu', 'Koçarlı', 'Köşk', 'Kuşadası', 'Kuyucak', 'Nazilli', 'Söke', 'Sultanhisar', 'Yenipazar'],
    'Balıkesir': ['Altıeylül', 'Ayvalık', 'Balya', 'Bandırma', 'Bigadiç', 'Burhaniye', 'Dursunbey', 'Edremit', 'Erdek', 'Gömeç', 'Gönen', 'Havran', 'İvrindi', 'Karesi', 'Kepsut', 'Manyas', 'Marmara', 'Savaştepe', 'Sındırgı', 'Susurluk'],
    'Bilecik': ['Bozüyük', 'Gölpazarı', 'İnhisar', 'Merkez', 'Osmaneli', 'Pazaryeri', 'Söğüt', 'Yenipazar'],
    'Bingöl': ['Adaklı', 'Genç', 'Karlıova', 'Kiğı', 'Merkez', 'Solhan', 'Yayladere', 'Yedisu'],
    'Bitlis': ['Adilcevaz', 'Ahlat', 'Güroymak', 'Hizan', 'Merkez', 'Mutki', 'Tatvan'],
    'Bolu': ['Dörtdivan', 'Gerede', 'Göynük', 'Kıbrıscık', 'Mengen', 'Merkez', 'Mudurnu', 'Seben', 'Yeniçağa'],
    'Burdur': ['Ağlasun', 'Altınyayla', 'Bucak', 'Çavdır', 'Çeltikçi', 'Gölhisar', 'Karamanlı', 'Kemer', 'Merkez', 'Tefenni', 'Yeşilova'],
    'Bursa': ['Büyükorhan', 'Gemlik', 'Gürsu', 'Harmancık', 'İnegöl', 'İznik', 'Karacabey', 'Keles', 'Kestel', 'Mudanya', 'Mustafakemalpaşa', 'Nilüfer', 'Orhaneli', 'Orhangazi', 'Osmangazi', 'Yenişehir', 'Yıldırım'],
    'Çanakkale': ['Ayvacık', 'Bayramiç', 'Biga', 'Bozcaada', 'Çan', 'Çanakkale', 'Eceabat', 'Ezine', 'Gelibolu', 'Gökçeada', 'Lapseki', 'Yenice'],
    'Çankırı': ['Atkaracalar', 'Bayramören', 'Çerkeş', 'Eldivan', 'Ilgaz', 'Kızılırmak', 'Korgun', 'Kurşunlu', 'Merkez', 'Orta', 'Şabanözü', 'Yapraklı'],
    'Çorum': ['Alaca', 'Bayat', 'Boğazkale', 'Dodurga', 'İskilip', 'Kargı', 'Laçin', 'Mecitözü', 'Merkez', 'Oğuzlar', 'Ortaköy', 'Osmancık', 'Sungurlu', 'Uğurludağ'],
    'Denizli': ['Acıpayam', 'Babadağ', 'Baklan', 'Bekilli', 'Beyağaç', 'Bozkurt', 'Buldan', 'Çal', 'Çameli', 'Çardak', 'Çivril', 'Güney', 'Honaz', 'Kale', 'Merkezefendi', 'Pamukkale', 'Sarayköy', 'Serinhisar', 'Tavas'],
    'Diyarbakır': ['Bağlar', 'Bismil', 'Çermik', 'Çınar', 'Çüngüş', 'Dicle', 'Eğil', 'Ergani', 'Hani', 'Hazro', 'Kayapınar', 'Kocaköy', 'Kulp', 'Lice', 'Silvan', 'Sur', 'Yenişehir'],
    'Edirne': ['Enez', 'Havsa', 'İpsala', 'Keşan', 'Lalapaşa', 'Meriç', 'Merkez', 'Süloğlu', 'Uzunköprü'],
    'Elazığ': ['Ağın', 'Alacakaya', 'Arıcak', 'Baskil', 'Karakoçan', 'Keban', 'Kovancılar', 'Maden', 'Merkez', 'Palu', 'Sivrice'],
    'Erzincan': ['Çayırlı', 'İliç', 'Kemah', 'Kemaliye', 'Merkez', 'Otlukbeli', 'Refahiye', 'Tercan', 'Üzümlü'],
    'Erzurum': ['Aşkale', 'Aziziye', 'Çat', 'Hınıs', 'Horasan', 'İspir', 'Karaçoban', 'Karayazı', 'Köprüköy', 'Narman', 'Oltu', 'Olur', 'Palandöken', 'Pasinler', 'Pazaryolu', 'Şenkaya', 'Tekman', 'Tortum', 'Uzundere', 'Yakutiye'],
    'Eskişehir': ['Alpu', 'Beylikova', 'Çifteler', 'Günyüzü', 'Han', 'İnönü', 'Mahmudiye', 'Mihalgazi', 'Mihalıççık', 'Odunpazarı', 'Sarıcakaya', 'Seyitgazi', 'Sivrihisar', 'Tepebaşı'],
    'Gaziantep': ['Araban', 'İslahiye', 'Karkamış', 'Nizip', 'Nurdağı', 'Oğuzeli', 'Şahinbey', 'Şehitkamil', 'Yavuzeli'],
    'Giresun': ['Alucra', 'Bulancak', 'Çamoluk', 'Çanakçı', 'Dereli', 'Doğankent', 'Espiye', 'Eynesil', 'Görele', 'Güce', 'Keşap', 'Merkez', 'Piraziz', 'Şebinkarahisar', 'Tirebolu', 'Yağlıdere'],
    'Gümüşhane': ['Kelkit', 'Köse', 'Kürtün', 'Merkez', 'Şiran', 'Torul'],
    'Hakkâri': ['Çukurca', 'Derecik', 'Merkez', 'Şemdinli', 'Yüksekova'],
    'Hatay': ['Altınözü', 'Antakya', 'Arsuz', 'Belen', 'Defne', 'Dörtyol', 'Erzin', 'Hassa', 'İskenderun', 'Kırıkhan', 'Kumlu', 'Payas', 'Reyhanlı', 'Samandağ', 'Yayladağı'],
    'Isparta': ['Aksu', 'Atabey', 'Eğirdir', 'Gelendost', 'Gönen', 'Keçiborlu', 'Merkez', 'Senirkent', 'Sütçüler', 'Şarkikaraağaç', 'Uluborlu', 'Yalvaç', 'Yenişarbademli'],
    'Mersin': ['Akdeniz', 'Anamur', 'Aydıncık', 'Bozyazı', 'Çamlıyayla', 'Erdemli', 'Gülnar', 'Mezitli', 'Mut', 'Silifke', 'Tarsus', 'Toroslar', 'Yenişehir'],
    'İstanbul': ['Adalar', 'Arnavutköy', 'Ataşehir', 'Avcılar', 'Bağcılar', 'Bahçelievler', 'Bakırköy', 'Başakşehir', 'Bayrampaşa', 'Beşiktaş', 'Beykoz', 'Beylikdüzü', 'Beyoğlu', 'Büyükçekmece', 'Çatalca', 'Çekmeköy', 'Esenler', 'Esenyurt', 'Eyüpsultan', 'Fatih', 'Gaziosmanpaşa', 'Güngören', 'Kadıköy', 'Kağıthane', 'Kartal', 'Küçükçekmece', 'Maltepe', 'Pendik', 'Sancaktepe', 'Sarıyer', 'Silivri', 'Sultanbeyli', 'Sultangazi', 'Şile', 'Şişli', 'Tuzla', 'Ümraniye', 'Üsküdar', 'Zeytinburnu'],
    'İzmir': ['Aliağa', 'Balçova', 'Bayındır', 'Bayraklı', 'Bergama', 'Beydağ', 'Bornova', 'Buca', 'Çeşme', 'Çiğli', 'Dikili', 'Foça', 'Gaziemir', 'Güzelbahçe', 'Karabağlar', 'Karaburun', 'Karşıyaka', 'Kemalpaşa', 'Kınık', 'Kiraz', 'Konak', 'Menderes', 'Menemen', 'Narlıdere', 'Ödemiş', 'Seferihisar', 'Selçuk', 'Tire', 'Torbalı', 'Urla'],
    'Kars': ['Akyaka', 'Arpaçay', 'Digor', 'Kağızman', 'Merkez', 'Sarıkamış', 'Selim', 'Susuz'],
    'Kastamonu': ['Abana', 'Ağlı', 'Araç', 'Azdavay', 'Bozkurt', 'Cide', 'Çatalzeytin', 'Daday', 'Devrekani', 'Doğanyurt', 'Hanönü', 'İhsangazi', 'İnebolu', 'Küre', 'Merkez', 'Pınarbaşı', 'Seydiler', 'Şenpazar', 'Taşköprü', 'Tosya'],
    'Kayseri': ['Akkışla', 'Bünyan', 'Develi', 'Felahiye', 'Hacılar', 'İncesu', 'Kocasinan', 'Melikgazi', 'Özvatan', 'Pınarbaşı', 'Sarıoğlan', 'Sarız', 'Talas', 'Tomarza', 'Yahyalı', 'Yeşilhisar'],
    'Kırklareli': ['Babaeski', 'Demirköy', 'Kofçaz', 'Lüleburgaz', 'Merkez', 'Pehlivanköy', 'Pınarhisar', 'Vize'],
    'Kırşehir': ['Akçakent', 'Akpınar', 'Boztepe', 'Çiçekdağı', 'Kaman', 'Merkez', 'Mucur'],
    'Kocaeli': ['Başiskele', 'Çayırova', 'Darıca', 'Derince', 'Dilovası', 'Gebze', 'Gölcük', 'İzmit', 'Kandıra', 'Karamürsel', 'Kartepe', 'Körfez'],
    'Konya': ['Ahırlı', 'Akören', 'Akşehir', 'Altınekin', 'Beyşehir', 'Bozkır', 'Cihanbeyli', 'Çeltik', 'Çumra', 'Derbent', 'Derebucak', 'Doğanhisar', 'Emirgazi', 'Ereğli', 'Güneysinir', 'Hadim', 'Halkapınar', 'Hüyük', 'Ilgın', 'Kadınhanı', 'Karapınar', 'Karatay', 'Kulu', 'Meram', 'Sarayönü', 'Selçuklu', 'Seydişehir', 'Taşkent', 'Tuzlukçu', 'Yalıhüyük', 'Yunak'],
    'Kütahya': ['Altıntaş', 'Aslanapa', 'Çavdarhisar', 'Domaniç', 'Dumlupınar', 'Emet', 'Gediz', 'Hisarcık', 'Merkez', 'Pazarlar', 'Simav', 'Şaphane', 'Tavşanlı'],
    'Malatya': ['Akçadağ', 'Arapgir', 'Arguvan', 'Battalgazi', 'Darende', 'Doğanşehir', 'Doğanyol', 'Hekimhan', 'Kale', 'Kuluncak', 'Pütürge', 'Yazıhan', 'Yeşilyurt'],
    'Manisa': ['Ahmetli', 'Akhisar', 'Alaşehir', 'Demirci', 'Gölmarmara', 'Gördes', 'Kırkağaç', 'Köprübaşı', 'Kula', 'Salihli', 'Sarıgöl', 'Saruhanlı', 'Selendi', 'Soma', 'Şehzadeler', 'Turgutlu', 'Yunusemre'],
    'Kahramanmaraş': ['Afşin', 'Andırın', 'Çağlayancerit', 'Dulkadiroğlu', 'Ekinözü', 'Elbistan', 'Göksun', 'Nurhak', 'Onikişubat', 'Pazarcık', 'Türkoğlu'],
    'Mardin': ['Artuklu', 'Dargeçit', 'Derik', 'Kızıltepe', 'Mazıdağı', 'Midyat', 'Nusaybin', 'Ömerli', 'Savur', 'Yeşilli'],
    'Muğla': ['Bodrum', 'Dalaman', 'Datça', 'Fethiye', 'Kavaklıdere', 'Köyceğiz', 'Marmaris', 'Menteşe', 'Milas', 'Ortaca', 'Seydikemer', 'Ula', 'Yatağan'],
    'Muş': ['Bulanık', 'Hasköy', 'Korkut', 'Malazgirt', 'Merkez', 'Varto'],
    'Nevşehir': ['Acıgöl', 'Avanos', 'Derinkuyu', 'Gülşehir', 'Hacıbektaş', 'Kozaklı', 'Merkez', 'Ürgüp'],
    'Niğde': ['Altunhisar', 'Bor', 'Çamardı', 'Çiftlik', 'Merkez', 'Ulukışla'],
    'Ordu': ['Akkuş', 'Altınordu', 'Aybastı', 'Çamaş', 'Çatalpınar', 'Çaybaşı', 'Fatsa', 'Gölköy', 'Gülyalı', 'Gürgentepe', 'İkizce', 'Kabadüz', 'Kabataş', 'Korgan', 'Kumru', 'Mesudiye', 'Perşembe', 'Piraziz', 'Ulubey', 'Ünye'],
    'Rize': ['Ardeşen', 'Çamlıhemşin', 'Çayeli', 'Derepazarı', 'Fındıklı', 'Güneysu', 'Hemşin', 'İkizdere', 'İyidere', 'Kalkandere', 'Merkez', 'Pazar'],
    'Sakarya': ['Adapazarı', 'Akyazı', 'Arifiye', 'Erenler', 'Ferizli', 'Geyve', 'Hendek', 'Karapürçek', 'Karasu', 'Kaynarca', 'Kocaali', 'Pamukova', 'Sapanca', 'Serdivan', 'Söğütlü', 'Taraklı'],
    'Samsun': ['19 Mayıs', 'Alaçam', 'Asarcık', 'Atakum', 'Ayvacık', 'Bafra', 'Canik', 'Çarşamba', 'Havza', 'İlkadım', 'Kavak', 'Ladik', 'Ondokuzmayıs', 'Salıpazarı', 'Tekkeköy', 'Terme', 'Vezirköprü', 'Yakakent'],
    'Siirt': ['Baykan', 'Eruh', 'Kurtalan', 'Merkez', 'Pervari', 'Şirvan'],
    'Sinop': ['Ayancık', 'Boyabat', 'Dikmen', 'Durağan', 'Erfelek', 'Gerze', 'Merkez', 'Saraydüzü', 'Türkeli'],
    'Sivas': ['Akıncılar', 'Altınyayla', 'Divriği', 'Doğanşar', 'Gemerek', 'Gölova', 'Gürün', 'Hafik', 'İmranlı', 'Kangal', 'Koyulhisar', 'Merkez', 'Suşehri', 'Şarkışla', 'Ulaş', 'Yıldızeli', 'Zara'],
    'Tekirdağ': ['Çerkezköy', 'Çorlu', 'Ergene', 'Hayrabolu', 'Kapaklı', 'Malkara', 'Marmaraereğlisi', 'Muratlı', 'Saray', 'Süleymanpaşa', 'Şarköy'],
    'Tokat': ['Almus', 'Artova', 'Başçiftlik', 'Erbaa', 'Merkez', 'Niksar', 'Pazar', 'Reşadiye', 'Sulusaray', 'Turhal', 'Yeşilyurt', 'Zile'],
    'Trabzon': ['Akçaabat', 'Araklı', 'Arsin', 'Beşikdüzü', 'Çarşıbaşı', 'Çaykara', 'Dernekpazarı', 'Düzköy', 'Hayrat', 'Köprübaşı', 'Maçka', 'Of', 'Ortahisar', 'Sürmene', 'Şalpazarı', 'Tonya', 'Vakfıkebir', 'Yomra'],
    'Tunceli': ['Çemişgezek', 'Hozat', 'Mazgirt', 'Merkez', 'Nazımiye', 'Ovacık', 'Pertek', 'Pülümür'],
    'Şanlıurfa': ['Akçakale', 'Birecik', 'Bozova', 'Ceylanpınar', 'Eyyübiye', 'Halfeti', 'Haliliye', 'Harran', 'Hilvan', 'Karaköprü', 'Siverek', 'Suruç', 'Viranşehir'],
    'Uşak': ['Banaz', 'Eşme', 'Karahallı', 'Merkez', 'Sivaslı', 'Ulubey'],
    'Van': ['Bahçesaray', 'Başkale', 'Çaldıran', 'Çatak', 'Edremit', 'Erciş', 'Gevaş', 'Gürpınar', 'İpekyolu', 'Muradiye', 'Özalp', 'Saray', 'Tuşba'],
    'Yozgat': ['Akdağmadeni', 'Aydıncık', 'Boğazlıyan', 'Çandır', 'Çayıralan', 'Çekerek', 'Kadışehri', 'Merkez', 'Saraykent', 'Sarıkaya', 'Sorgun', 'Şefaatli', 'Yenifakılı', 'Yerköy'],
    'Zonguldak': ['Alaplı', 'Çaycuma', 'Devrek', 'Gökçebey', 'Kilimli', 'Kozlu', 'Merkez'],
    'Aksaray': ['Ağaçören', 'Eskil', 'Gülağaç', 'Güzelyurt', 'Merkez', 'Ortaköy', 'Sarıyahşi'],
    'Bayburt': ['Aydıntepe', 'Demirözü', 'Merkez'],
    'Karaman': ['Ayrancı', 'Başyayla', 'Ermenek', 'Kazımkarabekir', 'Merkez', 'Sarıveliler'],
    'Kırıkkale': ['Bahşılı', 'Balışeyh', 'Çelebi', 'Delice', 'Karakeçili', 'Keskin', 'Merkez', 'Sulakyurt', 'Yahşihan'],
    'Batman': ['Beşiri', 'Gercüş', 'Hasankeyf', 'Kozluk', 'Merkez', 'Sason'],
    'Şırnak': ['Beytüşşebap', 'Cizre', 'Güçlükonak', 'İdil', 'Merkez', 'Silopi', 'Uludere'],
    'Bartın': ['Amasra', 'Kurucaşile', 'Merkez', 'Ulus'],
    'Ardahan': ['Çıldır', 'Damal', 'Göle', 'Hanak', 'Merkez', 'Posof'],
    'Iğdır': ['Aralık', 'Karakoyunlu', 'Merkez', 'Tuzluca'],
    'Yalova': ['Altınova', 'Armutlu', 'Çınarcık', 'Çiftlikköy', 'Merkez', 'Termal'],
    'Karabük': ['Eflani', 'Eskipazar', 'Merkez', 'Ovacık', 'Safranbolu', 'Yenice'],
    'Kilis': ['Elbeyli', 'Merkez', 'Musabeyli', 'Polateli'],
    'Osmaniye': ['Bahçe', 'Düziçi', 'Hasanbeyli', 'Kadirli', 'Merkez', 'Sumbas', 'Toprakkale'],
    'Düzce': ['Akçakoca', 'Cumayeri', 'Çilimli', 'Gölyaka', 'Gümüşova', 'Kaynaşlı', 'Merkez', 'Yığılca']
  };

  const getTodayDateOnly = () => new Date().toISOString().split('T')[0];
  const [balanceFormData, setBalanceFormData] = useState({
    type: '',
    amount: ''
  });
  const [amountInput, setAmountInput] = useState('');


  // Fetch customers
  const fetchCustomers = React.useCallback(async () => {
    try {
      setLoading(true);
      const params = {
        page: currentPage,
        limit: 50,
        search: searchTerm,
        sortBy: sortBy,
        sortOrder: sortOrder
      };

      const response = await customersAPI.getCustomers(params);
      setCustomers(response.data.customers);
      setTotalPages(response.data.pagination.totalPages);
    } catch (error) {
      console.error('Müşteriler yüklenemedi. Lütfen tekrar deneyin.');
      console.error('Fetch customers error:', error);
    } finally {
      setLoading(false);
    }
  }, [currentPage, searchTerm, sortBy, sortOrder]);

  // Search state for controlled input
  const [searchInput, setSearchInput] = useState('');

  // CustomerSelectModal approach - working search pattern
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSearchTerm(searchInput);
      setCurrentPage(1);
    }, 500); // 500ms debounce like in CustomerSelectModal

    return () => clearTimeout(timeoutId);
  }, [searchInput]);
  // Fetch deleted customers
  const fetchDeletedCustomers = React.useCallback(async () => {
    try {
      console.log('🔍 fetchDeletedCustomers çağrıldı');
      setDeletedCustomersLoading(true);
      const params = {
        page: 1,
        limit: 50,
        search: searchTerm
      };

      console.log('📡 API çağrısı yapılıyor:', params);
      const response = await customersAPI.getDeletedCustomers(params);
      console.log('✅ API yanıtı:', response.data);
      setDeletedCustomers(response.data.customers);
    } catch (error) {
      console.error('❌ Fetch deleted customers error:', error);
      console.error('Silinen müşteriler yüklenemedi');
    } finally {
      console.log('🏁 Loading state false yapılıyor');
      setDeletedCustomersLoading(false);
    }
  }, [searchTerm]);

  // Fetch Stats
  const fetchStats = React.useCallback(async () => {
    try {
      const response = await customersAPI.getStats({ dateRange: 'month' });
      setStats(response.data);
    } catch (error) {
      console.error('Stats fetching error:', error);
    }
  }, []);



  // Handle restore customer
  const handleRestoreCustomer = async (customerId) => {
    try {
      await customersAPI.restoreCustomer(customerId);
      console.log('Müşteri başarıyla geri yüklendi');
      fetchDeletedCustomers();
      fetchCustomers();
    } catch (error) {
      console.error('Restore customer error:', error);
      if (error.response?.data?.conflicts) {
        const conflicts = error.response.data.conflicts.join(', ');
        console.error(`Customer could not be restored: ${conflicts}`);
      } else {
        console.error('Customer could not be restored');
      }
    }
  };

  // Handle permanent delete customer
  const handlePermanentDeleteCustomer = async (customerId, customerName) => {
    if (window.confirm(`Are you sure you want to permanently delete customer "${customerName}"? This action cannot be undone!`)) {
      try {
        await customersAPI.permanentDeleteCustomer(customerId);
        console.log('Customer permanently deleted');
        fetchDeletedCustomers();
      } catch (error) {
        console.error('Permanent delete customer error:', error);
        if (error.response?.data?.message) {
          console.error(`${error.response.data.message}`);
        } else {
          console.error('Customer could not be permanently deleted');
        }
      }
    }
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user) {
      console.error('You must be logged in to perform this action.');
      showError('Oturum bulunamadı. Lütfen tekrar giriş yapın.');
      return;
    }

    // Basic validation
    if (!formData.firstName.trim()) {
      console.error('First name is required');
      return;
    }
    if (!formData.lastName.trim()) {
      console.error('Last name is required');
      return;
    }
    // Telefon formatı validasyonu (eğer girilmişse)
    if (formData.phone && formData.phone.trim()) {
      const phoneRegex = /^[0-9+\-\s()]+$/;
      if (!phoneRegex.test(formData.phone.trim())) {
        console.error('Please enter a valid phone number (e.g: 0555 123 45 67)');
        return;
      }

      if (formData.phone.trim().length < 10 || formData.phone.trim().length > 15) {
        console.error('Phone number must be between 10-15 characters');
        return;
      }
    }

    try {
      setFormSubmitting(true);

      console.log('Form data being submitted:', formData);

      if (selectedCustomer) {
        // Update existing customer
        console.log('Updating customer with user ID:', user?.id, 'User email:', user?.email);
        await customersAPI.updateCustomer(selectedCustomer.id, formData, user?.id);
        console.log('Customer updated successfully');
      } else {
        // Create new customer
        console.log('Creating customer with user ID:', user?.id, 'User email:', user?.email);
        const result = await customersAPI.createCustomer(formData, user?.id);
        console.log('Customer created successfully:', result);
      }

      // Close modals and reset state
      resetForm();

      // Refresh data
      fetchCustomers();

    } catch (error) {
      console.error('Submit error:', error);
      console.error('Error details:', error.response?.data);

      let errorMessage = 'Müşteri kaydedilemedi';

      if (error.response?.data?.details) {
        // Validation hatalarını detaylı göster
        const validationErrors = error.response.data.details;
        validationErrors.forEach(err => {
          console.error(`${err.field}: ${err.message}`);
        });
        errorMessage = 'Form verilerinde hata var. Lütfen kontrol edin.';
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      showError(errorMessage);
    } finally {
      setFormSubmitting(false);
    }
  };

  // Handle delete
  const handleDelete = async (customerId) => {
    if (window.confirm('Bu müşteriyi ve tüm ilgili verilerini (ürün işlemleri, bakiye işlemleri) kalıcı olarak silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.')) {
      try {
        setFormSubmitting(true);
        await customersAPI.deleteCustomer(customerId);
        console.log('Customer and all related data deleted permanently');
        showSuccess('Müşteri ve tüm ilgili veriler kalıcı olarak silindi');
        fetchCustomers();
      } catch (error) {
        console.error('Customer could not be deleted');
        console.error('Delete error:', error);
        showError('Müşteri silinemedi: ' + (error.message || 'Bilinmeyen hata'));
      } finally {
        setFormSubmitting(false);
      }
    }
  };

  // Reset form and modals
  const resetForm = () => {
    setSelectedCustomer(null);
    setShowAddModal(false);
    setShowEditModal(false);
    setFormData({
      firstName: '',
      lastName: '',
      phone: '',
      tcNumber: '',
      address: '',
      city: '',
      district: '',
      postalCode: '',
      preferredColors: [],
      preferredBrands: [],
      smsPermission: true,
      emailPermission: true,
      notes: ''
    });
    setBalanceFormData({
      type: 'payment',
      amount: '',
      description: '',
      date: getTodayDateOnly(),
      notes: ''
    });
  };

  // Handle edit
  const handleEdit = (customer) => {
    setSelectedCustomer(customer);
    setFormData({
      firstName: customer.firstName || '',
      lastName: customer.lastName || '',
      phone: customer.phone || '',
      tcNumber: customer.tcNumber || '',
      address: customer.address || '',
      city: customer.city || '',
      district: customer.district || '',
      postalCode: customer.postalCode || '',
      preferredColors: customer.preferredColors || [],
      preferredBrands: customer.preferredBrands || [],
      smsPermission: customer.smsPermission !== false,
      emailPermission: customer.emailPermission !== false,
      notes: customer.notes || ''
    });
    setShowEditModal(true);
  };



  const handleBalanceSubmit = async (e) => {
    e.preventDefault();

    if (!balanceFormData.amount || !balanceFormData.type) {
      console.error('Amount and type fields are required');
      return;
    }

    try {
      setFormSubmitting(true);

      // Auto-generate current date and time
      const transactionData = {
        ...balanceFormData,
        date: getTodayDateOnly(),
        description: balanceFormData.type, // Use operation type as description
        notes: ''
      };

      await customersAPI.addBalanceTransaction(selectedCustomer.id, transactionData);
      console.log(`Balance transaction added: ${balanceFormData.type}`);
      setShowBalanceModal(false);
      setBalanceFormData({
        type: '',
        amount: ''
      });
      setAmountInput('');
      fetchCustomers();
    } catch (error) {
      console.error('Balance transaction error:', error);
      if (error.response?.data?.message) {
        console.error(error.response.data.message);
      } else {
        console.error('Balance transaction could not be added');
      }
    } finally {
      setFormSubmitting(false);
    }
  };

  const handleBalanceInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'type') {
      setBalanceFormData(prev => ({
        ...prev,
        [name]: value,
        description: value === 'payment' ? 'Ödeme alındı' : ''
      }));
    } else {
      setBalanceFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  // Handle sorting
  const handleSort = (column) => {
    if (sortBy === column) {
      // Toggle sort order if same column
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      // Set new column and default to desc
      setSortBy(column);
      setSortOrder('desc');
    }
    setCurrentPage(1); // Reset to first page when sorting changes
  };

  // Amount input handlers for better UX
  const sanitizeAmountInputTR = (input) => {
    if (!input) return '';
    // Allow digits and comma/dot, convert dot to comma
    let value = input.replace(/\./g, ',').replace(/[^0-9,]/g, '');
    // Keep only first comma
    const parts = value.split(',');
    value = parts[0] + (parts.length > 1 ? ',' + parts.slice(1).join('').slice(0, 2) : '');
    return value;
  };

  const handleAmountChange = (e) => {
    const raw = e.target.value;
    const clean = sanitizeAmountInputTR(raw);
    setAmountInput(clean);
    const numeric = parseFormattedNumber(clean);
    setBalanceFormData(prev => ({ ...prev, amount: numeric }));
  };

  const handleAmountBlur = () => {
    const numeric = parseFormattedNumber(amountInput);
    if (!isNaN(numeric)) {
      setAmountInput(formatNumberForDisplay(numeric));
    } else {
      setAmountInput('');
    }
  };


  // Handle input change
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Special handling for TC number field
    if (name === 'tcNumber') {
      // Only allow numeric input and limit to 11 characters
      const numericValue = value.replace(/[^0-9]/g, '').slice(0, 11);
      setFormData(prev => ({
        ...prev,
        [name]: numericValue
      }));
      return;
    }

    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
      // Reset district when city changes
      ...(name === 'city' && { district: '' })
    }));
  };

  useEffect(() => {
    fetchCustomers();
    fetchStats();
  }, [currentPage, searchTerm, fetchCustomers, fetchStats]);



  // Satış silme işleminden sonra müşteri listesini güncelle
  useEffect(() => {
    const handleSaleDeleted = () => {
      console.log('📢 Customers: Satış silindi, müşteri listesi güncelleniyor...');
      fetchCustomers(); // Müşteri listesini de yenile
    };

    // Custom event listener ekle
    window.addEventListener('saleDeleted', handleSaleDeleted);

    // Ayrıca sayfa focus olduğunda da güncelle
    const handleFocus = () => {
      console.log('Sayfa focus oldu, müşteri listesi güncelleniyor...');
      fetchCustomers();
    };

    window.addEventListener('focus', handleFocus);

    return () => {
      window.removeEventListener('saleDeleted', handleSaleDeleted);
      window.removeEventListener('focus', handleFocus);
    };
  }, [fetchCustomers]);

  // Sayfa görünür olduğunda müşteri listesini güncelle
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        console.log('Sayfa görünür oldu, müşteri listesi güncelleniyor...');
        fetchCustomers();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [fetchCustomers]);

  useEffect(() => {
    console.log('🔄 useEffect showDeletedCustomers değişti:', showDeletedCustomers);
    if (showDeletedCustomers) {
      console.log('📥 Silinen müşteriler yükleniyor...');
      fetchDeletedCustomers();
    }
  }, [showDeletedCustomers, fetchDeletedCustomers]);

  return (
    <div className="h-screen bg-gray-50 flex flex-col overflow-hidden">
      <PageToolbar
        title={
          <div className="flex items-center gap-4">
            <span>Müşteriler</span>
            <div className="flex items-center gap-1.5 px-2 py-0.5 bg-blue-50 text-blue-600 rounded-md border border-blue-100/50">
              <UsersIcon className="w-3.5 h-3.5" />
              <span className="text-xs font-bold leading-none">{stats.totalCustomers}</span>
            </div>
          </div>
        }
        right={
          <div className="flex flex-wrap items-center gap-3">
            <button
              onClick={() => { fetchCustomers(); }}
              className="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
              title="Müşteri Listesini Yenile"
            >
              <RefreshCw className="w-4 h-4" />
              Yenile
            </button>
            <button
              onClick={() => setShowDeletedCustomers(!showDeletedCustomers)}
              className={`inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${showDeletedCustomers
                ? 'border border-red-300 bg-red-50 text-red-700 hover:bg-red-100 focus:ring-red-500'
                : 'border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-blue-500'
                }`}
            >
              {showDeletedCustomers ? 'Aktif Müşteriler' : 'Silinen Müşteriler'}
            </button>
            {canCreateCustomer() && (
              <button
                onClick={() => {
                  setShowAddModal(true);
                  setFormData({
                    firstName: '',
                    lastName: '',
                    phone: '',
                    tcNumber: '',
                    address: '',
                    city: '',
                    district: '',
                    postalCode: '',
                    preferredColors: [],
                    preferredBrands: [],
                    smsPermission: true,
                    emailPermission: true,
                    notes: ''
                  });
                }}
                className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-blue-700"
              >
                <Plus className="w-4 h-4" />
                Yeni Müşteri
              </button>
            )}
          </div>
        }
      >
        <div className="relative w-full sm:w-80">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
          <input
            type="text"
            placeholder="Müşteri adı, telefon veya TC ara..."
            className="w-full rounded-lg border border-gray-300 bg-gray-50 py-2 pl-9 pr-4 text-sm focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-200"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
          />
        </div>
      </PageToolbar>

      {/* Customers Table - Scrollable content area */}
      <div className="flex-1 bg-white overflow-hidden flex flex-col min-h-0">
        <div className="flex-1 overflow-y-auto">
          {loading ? (
            <div className="p-12 text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
              <p className="mt-4 text-gray-600">Müşteriler yükleniyor...</p>
            </div>
          ) : showDeletedCustomers ? (
            deletedCustomersLoading ? (
              <div className="p-12 text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto"></div>
                <p className="mt-4 text-gray-600">Silinen müşteriler yükleniyor...</p>
              </div>
            ) : deletedCustomers.length === 0 ? (
              <div className="p-12 text-center">
                <div className="text-gray-400 mb-4">
                  <UsersIcon className="h-12 w-12 mx-auto" />
                </div>
                <p className="text-gray-600">Silinen müşteri bulunamadı</p>
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 text-sm">
                  <thead className="bg-red-50">
                    <tr className="border-b border-red-200">
                      <th className="px-3 py-2 text-left text-xs font-semibold text-red-700 uppercase tracking-wider">
                        Silinen Müşteri
                      </th>
                      <th className="px-3 py-2 text-left text-xs font-semibold text-red-700 uppercase tracking-wider">
                        Telefon
                      </th>
                      <th className="px-3 py-2 text-left text-xs font-semibold text-red-700 uppercase tracking-wider">
                        Şehir
                      </th>
                      <th className="px-3 py-2 text-right text-xs font-semibold text-red-700 uppercase tracking-wider">
                        Ödeme
                      </th>
                      <th className="px-3 py-2 text-left text-xs font-semibold text-red-700 uppercase tracking-wider">
                        Silinen Tarih
                      </th>
                      <th className="px-3 py-2 text-center text-xs font-semibold text-red-700 uppercase tracking-wider w-32">
                        İşlemler
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {deletedCustomers.map((customer) => (
                      <tr
                        key={customer.id}
                        className="hover:bg-red-50 transition-colors border-b border-gray-100"
                      >
                        <td className="px-3 py-2 whitespace-nowrap">
                          <div className="text-sm font-medium text-gray-900">
                            {displayUpperCase(customer.fullName)}
                          </div>
                          {customer.tcNumber && (
                            <div className="text-xs text-gray-500">
                              TC: {displayUpperCase(customer.tcNumber)}
                            </div>
                          )}
                        </td>
                        <td className="px-3 py-2 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            {displayUpperCase(customer.phone) || '-'}
                          </div>
                        </td>
                        <td className="px-3 py-2 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            {displayUpperCase(customer.city) || '-'}
                          </div>
                        </td>
                        <td className="px-3 py-2 whitespace-nowrap text-right">
                          <div className="text-sm font-semibold">
                            <span className={customer.balance > 0 ? 'text-red-600' : customer.balance < 0 ? 'text-green-600' : 'text-gray-600'}>
                              {formatNumberForDisplay(customer.balance) || '0,00'} ₺
                            </span>
                          </div>
                        </td>
                        <td className="px-3 py-2 whitespace-nowrap">
                          <div className="text-xs text-gray-600">
                            {new Date(customer.updatedAt).toLocaleDateString('tr-TR', {
                              year: '2-digit',
                              month: '2-digit',
                              day: '2-digit'
                            })}
                          </div>
                          <div className="text-xs text-gray-400">
                            {new Date(customer.updatedAt).toLocaleTimeString('tr-TR', {
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                          </div>
                        </td>
                        <td className="px-3 py-2 whitespace-nowrap text-center">
                          <div className="flex items-center justify-center space-x-1">
                            <button
                              onClick={() => handleRestoreCustomer(customer.id)}
                              className="inline-flex items-center px-2 py-1 border border-transparent text-xs font-medium rounded text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-1 focus:ring-green-500 transition-colors"
                              title="Geri Yükle"
                            >
                              <RotateCcw className="w-3 h-3 mr-1" />
                              Geri
                            </button>
                            <button
                              onClick={() => handlePermanentDeleteCustomer(customer.id, customer.fullName)}
                              className="inline-flex items-center px-2 py-1 border border-transparent text-xs font-medium rounded text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-1 focus:ring-red-500 transition-colors"
                              title="Kalıcı Sil"
                            >
                              <Trash2 className="w-3 h-3 mr-1" />
                              Sil
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200 text-sm">
                <thead className="bg-gray-50">
                  <tr className="border-b border-gray-200">
                    <th
                      className="px-3 py-2 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none"
                      onClick={() => handleSort('firstName')}
                    >
                      <div className="flex items-center gap-1">
                        Müşteri Adı
                        <div className="flex flex-col">
                          <ChevronUp
                            size={10}
                            className={`${sortBy === 'firstName' && sortOrder === 'asc' ? 'text-blue-600' : 'text-gray-400'}`}
                          />
                          <ChevronDown
                            size={10}
                            className={`${sortBy === 'firstName' && sortOrder === 'desc' ? 'text-blue-600' : 'text-gray-400'} -mt-1`}
                          />
                        </div>
                      </div>
                    </th>
                    <th className="px-3 py-2 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                      Telefon
                    </th>
                    <th className="px-3 py-2 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                      Şehir
                    </th>
                    <th className="px-3 py-2 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                      TC
                    </th>
                    <th
                      className="px-3 py-2 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none"
                      onClick={() => handleSort('createdAt')}
                    >
                      <div className="flex items-center gap-1">
                        Oluşturan
                        <div className="flex flex-col">
                          <ChevronUp
                            size={10}
                            className={`${sortBy === 'createdAt' && sortOrder === 'asc' ? 'text-blue-600' : 'text-gray-400'}`}
                          />
                          <ChevronDown
                            size={10}
                            className={`${sortBy === 'createdAt' && sortOrder === 'desc' ? 'text-blue-600' : 'text-gray-400'} -mt-1`}
                          />
                        </div>
                      </div>
                    </th>
                    <th
                      className="px-3 py-2 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none"
                      onClick={() => handleSort('updatedAt')}
                    >
                      <div className="flex items-center gap-1">
                        Son Güncelleme
                        <div className="flex flex-col">
                          <ChevronUp
                            size={10}
                            className={`${sortBy === 'updatedAt' && sortOrder === 'asc' ? 'text-blue-600' : 'text-gray-400'}`}
                          />
                          <ChevronDown
                            size={10}
                            className={`${sortBy === 'updatedAt' && sortOrder === 'desc' ? 'text-blue-600' : 'text-gray-400'} -mt-1`}
                          />
                        </div>
                      </div>
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider w-24">
                      İşlemler
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {showDeletedCustomers ? (
                    // Bu bölüm artık yukarıda tanımlanmış olduğu için buraya bir şey yazmayacağız
                    // Silinen müşteriler artık üstteki bölümde gösteriliyor
                    null
                  ) : (
                    // Aktif müşteriler listesi
                    customers.map((customer) => (
                      <tr
                        key={customer.id}
                        className="hover:bg-gray-50 cursor-pointer transition-colors border-b border-gray-100 laptop-table-row"
                        onDoubleClick={() => navigate(`/customers/${customer.id}`)}
                      >
                        {/* Müşteri Adı */}
                        <td className="px-3 py-2 whitespace-nowrap">
                          <div className="text-sm font-medium text-gray-900">
                            {displayUpperCase(customer.fullName)}
                          </div>
                        </td>


                        {/* Telefon */}
                        <td className="px-3 py-2 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            {displayUpperCase(customer.phone) || '-'}
                          </div>
                        </td>

                        {/* Şehir */}
                        <td className="px-3 py-2 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            {displayUpperCase(customer.city) || '-'}
                          </div>
                        </td>

                        {/* TC */}
                        <td className="px-3 py-2 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            {displayUpperCase(customer.tcNumber) || '-'}
                          </div>
                        </td>

                        {/* Oluşturan */}
                        <td className="px-3 py-2 whitespace-nowrap">
                          <div className="text-xs text-gray-600">
                            Sistem
                          </div>
                          <div className="text-xs text-gray-400">
                            {new Date(customer.createdAt).toLocaleDateString('tr-TR')}
                          </div>
                        </td>

                        {/* Son Güncelleme */}
                        <td className="px-3 py-2 whitespace-nowrap">
                          <div className="text-xs text-gray-600">
                            {new Date(customer.updatedAt).toLocaleDateString('tr-TR', {
                              year: '2-digit',
                              month: '2-digit',
                              day: '2-digit'
                            })}
                          </div>
                          <div className="text-xs text-gray-400">
                            {new Date(customer.updatedAt).toLocaleTimeString('tr-TR', {
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                          </div>
                        </td>

                        {/* İşlemler */}
                        <td className="px-3 py-2 whitespace-nowrap text-center">
                          <div className="flex items-center justify-center space-x-1">
                            {canUpdateCustomer() && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleEdit(customer);
                                }}
                                className="inline-flex items-center p-1 border border-transparent text-xs font-medium rounded text-amber-700 bg-amber-100 hover:bg-amber-200 focus:outline-none focus:ring-1 focus:ring-amber-500 transition-colors"
                                title="Düzenle"
                              >
                                <Edit className="w-3 h-3" />
                              </button>
                            )}
                            {canDeleteCustomer() && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDelete(customer.id);
                                }}
                                disabled={formSubmitting}
                                className="inline-flex items-center p-1 border border-transparent text-xs font-medium rounded text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-1 focus:ring-red-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                title="Sil"
                              >
                                <Trash2 className="w-3 h-3" />
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Pagination Fixed at Bottom */}
        {!loading && !showDeletedCustomers && totalPages > 1 && (
          <div className="border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
            <div className="flex items-center justify-between sm:hidden">
              <button
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="relative inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Önceki
              </button>
              <span className="text-xs text-gray-600 self-center">
                Sayfa {currentPage} / {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="relative inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Sonraki
              </button>
            </div>
            <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
              <div>
                <p className="text-xs text-gray-600">
                  <span className="font-medium">{customers.length}</span> kayıt gösteriliyor
                </p>
                <p className="text-xs text-gray-600 mt-0.5">
                  Sayfa <span className="font-medium">{currentPage}</span> / <span className="font-medium">{totalPages}</span>
                </p>
              </div>
              <div>
                <nav className="relative z-0 inline-flex rounded shadow-sm -space-x-px">
                  <button
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    className="relative inline-flex items-center px-2 py-1.5 rounded-l border border-gray-300 bg-white text-xs font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Önceki
                  </button>
                  <button
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    className="relative inline-flex items-center px-2 py-1.5 rounded-r border border-gray-300 bg-white text-xs font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Sonraki
                  </button>
                </nav>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Add/Edit Modal */}
      {
        (showAddModal || showEditModal) && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-5xl max-h-[90vh] overflow-y-auto">
              <div className="px-6 py-4 border-b border-gray-200">
                <div className="flex justify-between items-center">
                  <h2 className="text-xl font-semibold text-gray-900">
                    {showEditModal ? 'Müşteri Düzenle' : 'Yeni Müşteri Ekle'}
                  </h2>
                  <button
                    onClick={resetForm}
                    className="text-gray-400 hover:text-gray-600 transition-colors"
                  >
                    <X className="w-6 h-6" />
                  </button>
                </div>
              </div>
              <form onSubmit={handleSubmit} className="p-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  {/* Sol Kolon - Temel Bilgiler */}
                  <div className="space-y-6">
                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-medium text-gray-900 mb-6 flex items-center">
                        <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                        Temel Bilgiler
                      </h3>

                      <div className="space-y-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Ad <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              name="firstName"
                              value={formData.firstName}
                              onChange={handleInputChange}
                              required
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Soyad <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              name="lastName"
                              value={formData.lastName}
                              onChange={handleInputChange}
                              required
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">TC Kimlik No</label>
                            <input
                              type="text"
                              name="tcNumber"
                              value={formData.tcNumber}
                              onChange={handleInputChange}
                              maxLength="11"
                              pattern="[0-9]{11}"
                              inputMode="numeric"
                              placeholder="11 haneli TC kimlik numarası"
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">Telefon</label>
                            <input
                              type="tel"
                              name="phone"
                              value={formData.phone}
                              onChange={handleInputChange}
                              pattern="[0-9+\-\s()]+"
                              minLength="10"
                              maxLength="11"
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Sağ Kolon - Adres Bilgileri */}
                  <div className="space-y-6">
                    <div className="bg-blue-50 rounded-lg p-6">
                      <h3 className="text-lg font-medium text-gray-900 mb-6 flex items-center">
                        <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                        Adres Bilgileri
                      </h3>

                      <div className="space-y-6">
                        {/* Ana Adres */}
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Ana Adres
                          </label>
                          <textarea
                            name="address"
                            value={formData.address}
                            onChange={handleInputChange}
                            rows="4"
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none transition-colors"
                          />
                        </div>

                        {/* Şehir ve İlçe */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">Şehir</label>
                            <select
                              name="city"
                              value={formData.city}
                              onChange={handleInputChange}
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                            >
                              <option value="">Şehir seçiniz</option>
                              <option value="Adana">Adana</option>
                              <option value="Adıyaman">Adıyaman</option>
                              <option value="Afyonkarahisar">Afyonkarahisar</option>
                              <option value="Ağrı">Ağrı</option>
                              <option value="Amasya">Amasya</option>
                              <option value="Ankara">Ankara</option>
                              <option value="Antalya">Antalya</option>
                              <option value="Artvin">Artvin</option>
                              <option value="Aydın">Aydın</option>
                              <option value="Balıkesir">Balıkesir</option>
                              <option value="Bilecik">Bilecik</option>
                              <option value="Bingöl">Bingöl</option>
                              <option value="Bitlis">Bitlis</option>
                              <option value="Bolu">Bolu</option>
                              <option value="Burdur">Burdur</option>
                              <option value="Bursa">Bursa</option>
                              <option value="Çanakkale">Çanakkale</option>
                              <option value="Çankırı">Çankırı</option>
                              <option value="Çorum">Çorum</option>
                              <option value="Denizli">Denizli</option>
                              <option value="Diyarbakır">Diyarbakır</option>
                              <option value="Edirne">Edirne</option>
                              <option value="Elazığ">Elazığ</option>
                              <option value="Erzincan">Erzincan</option>
                              <option value="Erzurum">Erzurum</option>
                              <option value="Eskişehir">Eskişehir</option>
                              <option value="Gaziantep">Gaziantep</option>
                              <option value="Giresun">Giresun</option>
                              <option value="Gümüşhane">Gümüşhane</option>
                              <option value="Hakkâri">Hakkâri</option>
                              <option value="Hatay">Hatay</option>
                              <option value="Isparta">Isparta</option>
                              <option value="Mersin">Mersin</option>
                              <option value="İstanbul">İstanbul</option>
                              <option value="İzmir">İzmir</option>
                              <option value="Kars">Kars</option>
                              <option value="Kastamonu">Kastamonu</option>
                              <option value="Kayseri">Kayseri</option>
                              <option value="Kırklareli">Kırklareli</option>
                              <option value="Kırşehir">Kırşehir</option>
                              <option value="Kocaeli">Kocaeli</option>
                              <option value="Konya">Konya</option>
                              <option value="Kütahya">Kütahya</option>
                              <option value="Malatya">Malatya</option>
                              <option value="Manisa">Manisa</option>
                              <option value="Kahramanmaraş">Kahramanmaraş</option>
                              <option value="Mardin">Mardin</option>
                              <option value="Muğla">Muğla</option>
                              <option value="Muş">Muş</option>
                              <option value="Nevşehir">Nevşehir</option>
                              <option value="Niğde">Niğde</option>
                              <option value="Ordu">Ordu</option>
                              <option value="Rize">Rize</option>
                              <option value="Sakarya">Sakarya</option>
                              <option value="Samsun">Samsun</option>
                              <option value="Siirt">Siirt</option>
                              <option value="Sinop">Sinop</option>
                              <option value="Sivas">Sivas</option>
                              <option value="Tekirdağ">Tekirdağ</option>
                              <option value="Tokat">Tokat</option>
                              <option value="Trabzon">Trabzon</option>
                              <option value="Tunceli">Tunceli</option>
                              <option value="Şanlıurfa">Şanlıurfa</option>
                              <option value="Uşak">Uşak</option>
                              <option value="Van">Van</option>
                              <option value="Yozgat">Yozgat</option>
                              <option value="Zonguldak">Zonguldak</option>
                              <option value="Aksaray">Aksaray</option>
                              <option value="Bayburt">Bayburt</option>
                              <option value="Karaman">Karaman</option>
                              <option value="Kırıkkale">Kırıkkale</option>
                              <option value="Batman">Batman</option>
                              <option value="Şırnak">Şırnak</option>
                              <option value="Bartın">Bartın</option>
                              <option value="Ardahan">Ardahan</option>
                              <option value="Iğdır">Iğdır</option>
                              <option value="Yalova">Yalova</option>
                              <option value="Karabük">Karabük</option>
                              <option value="Kilis">Kilis</option>
                              <option value="Osmaniye">Osmaniye</option>
                              <option value="Düzce">Düzce</option>
                            </select>
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">İlçe</label>
                            <select
                              name="district"
                              value={formData.district}
                              onChange={handleInputChange}
                              disabled={!formData.city}
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
                            >
                              <option value="">İlçe seçiniz</option>
                              {formData.city && districtsData[formData.city]?.map((district) => (
                                <option key={district} value={district}>
                                  {district}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>


                {/* Buttons */}
                <div className="flex justify-end gap-4 pt-8 mt-8 border-t border-gray-200">
                  <button
                    type="button"
                    onClick={resetForm}
                    className="px-8 py-3 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 font-medium transition-colors"
                  >
                    İptal
                  </button>
                  <button
                    type="submit"
                    disabled={formSubmitting}
                    className="px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {formSubmitting ? 'İşleniyor...' : (showEditModal ? 'Güncelle' : 'Kaydet')}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )
      }

      {/* Balance Transaction Modal */}
      {
        showBalanceModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto">
              <div className="px-6 py-4 border-b border-gray-200">
                <h2 className="text-xl font-semibold text-gray-900">
                  {selectedCustomer?.fullName} - Ödeme İşlemi
                </h2>
              </div>
              <form onSubmit={handleBalanceSubmit} className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Yapılan İşlem</label>
                  <input
                    type="text"
                    name="type"
                    value={balanceFormData.type}
                    onChange={handleBalanceInputChange}
                    placeholder="Yapılan işlemi yazın (örn: Tamir, Bakım, Satış)"
                    className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Tutar</label>
                  <div className="relative">
                    <input
                      type="text"
                      name="amount"
                      value={amountInput}
                      onChange={handleAmountChange}
                      onBlur={handleAmountBlur}
                      placeholder="0,00"
                      inputMode="decimal"
                      pattern="[0-9.,]+"
                      className="w-full pr-10 px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-right text-lg font-semibold"
                    />
                    <span className="absolute inset-y-0 right-3 flex items-center text-gray-500">₺</span>
                  </div>
                </div>
                <div className="p-3 bg-gray-50 rounded-lg">
                  <p className="text-sm text-gray-600">Geçmiş Ödeme:</p>
                  <p className={`text-lg font-bold ${selectedCustomer?.balance > 0 ? 'text-red-600' : selectedCustomer?.balance < 0 ? 'text-green-600' : 'text-gray-600'}`}>
                    {formatNumberForDisplay(Math.abs(selectedCustomer?.balance || 0))} ₺
                  </p>
                </div>
                <div className="flex justify-end gap-3">
                  <button
                    type="button"
                    onClick={() => {
                      setShowBalanceModal(false);
                      setBalanceFormData({
                        type: '',
                        amount: ''
                      });
                    }}
                    className="px-6 py-2.5 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 font-medium transition-colors"
                  >
                    İptal
                  </button>
                  <button
                    type="submit"
                    disabled={formSubmitting}
                    className="px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {formSubmitting ? 'İşleniyor...' : 'İşlemi Kaydet'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )
      }

      {/* Customers List Modal */}
      {
        showCustomersListModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[80vh] overflow-y-auto">
              <div className="px-6 py-4 border-b border-gray-200">
                <div className="flex justify-between items-center">
                  <h2 className="text-xl font-semibold text-gray-900">Müşteri Listesi (Alfabetik Sıralı)</h2>
                  <button
                    onClick={() => setShowCustomersListModal(false)}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <X className="w-6 h-6" />
                  </button>
                </div>
              </div>
              <div className="p-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {customers
                    .sort((a, b) => a.fullName.localeCompare(b.fullName, 'tr'))
                    .map((customer) => (
                      <div
                        key={customer.id}
                        className="p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
                        onClick={() => {
                          setShowCustomersListModal(false);
                          navigate(`/customers/${customer.id}`);
                        }}
                      >
                        <div className="font-medium text-gray-900">{displayUpperCase(customer.fullName)}</div>
                        <div className="text-sm text-gray-500">{displayUpperCase(customer.phone)}</div>
                        {customer.tcNumber && (
                          <div className="text-xs text-gray-400">TC: {displayUpperCase(customer.tcNumber)}</div>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        )
      }
    </div >
  );
};

export default Customers;
